import Data from './data'

export default {
    get: () => [200, Data.get],
    detail: () => [200, Data.detail],
}
